import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login?error=1", { replace: true });
      }
    })();
     
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F1EE]">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="inline-block w-10 h-10 border-2 border-[#1A362D] border-t-transparent rounded-full animate-spin" />
        <p className="mt-4 font-body text-[#5C6B64]">Signing you in…</p>
      </div>
    </div>
  );
}
